module.exports = __webpack_public_path__ + "static/tabpane-244a82964bef696d69d4406903bb27aa.png";